import { get, startCase } from 'lodash';
import ProductType from '../../Constants/ProductType';

export default function makeProductTitle(product) {
  return product.productType === ProductType.PRODUCT
    ? get(product, `collection.title`, 'film rolls')
    : startCase(product.productType);
}
